import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ArrowRight, Loader2 } from 'lucide-react';
import ProductCard from '../components/ProductCard';
import { useAuth } from '../context/AuthContext';
import { useFavorites } from '../context/FavoritesContext';

const FavoritesPage = () => {
  const { user } = useAuth();
  const { products, loading, count } = useFavorites();

  if (!user) {
    return (
      <div className="max-w-[900px] mx-auto px-4 py-16 text-center">
        <Heart className="w-10 h-10 text-[#F46A25] mx-auto mb-3" />
        <h1 className="text-2xl md:text-3xl font-black text-[#12263A] mb-2">My Wishlist</h1>
        <p className="text-neutral-600 mb-6">Sign in to save products to your wishlist and access them from any device.</p>
        <Link to="/login?redirect=%2Ffavorites" className="inline-flex items-center gap-2 bg-[#F46A25] hover:bg-[#e05a15] text-white font-bold px-6 py-3 rounded-sm">
          Sign in <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-4 py-8">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-xs uppercase font-bold text-[#F46A25] mb-1">My account</div>
          <h1 className="text-2xl md:text-3xl font-black text-[#12263A]">My Wishlist <span className="text-neutral-400 font-semibold">({count})</span></h1>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-[#F46A25]" /></div>
      ) : products.length === 0 ? (
        <div className="bg-white border border-neutral-200 rounded-sm p-10 text-center">
          <Heart className="w-10 h-10 text-neutral-300 mx-auto mb-3" />
          <div className="font-bold text-[#12263A] mb-1">Your wishlist is empty</div>
          <p className="text-sm text-neutral-600 mb-4">Tap the heart on any product to save it here for later.</p>
          <Link to="/" className="inline-flex items-center gap-2 bg-[#F46A25] hover:bg-[#e05a15] text-white font-bold px-5 py-2.5 rounded-sm text-sm">
            Start shopping <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default FavoritesPage;
